<template>
  <div class="wifi__content">
    <vs-progress v-if="!is_auth" indeterminate color="primary"></vs-progress>
    <div class="frame">
      <iframe src="https://wifi.smart-english-school.ru/staff" v-if="is_auth"></iframe>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Wifi Settings',
  data() {
    return {
      is_auth: false
    }
  },  
  methods: {
    go: function(){
      window.open('https://wifi.smart-english-school.ru/staff', '_blank')
    }
  },
  created: async function (){
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI
    let url = proxy + api_uri + "/guest_wifi"
    return Vue.http
        .post(url, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
          if (response.status == 200){
            setTimeout(() => {
              this.is_auth = true
            },100)
          }
        }).catch(() => { throw "Ошибка сохранения" })
  } 
}
</script>
<style lang="scss">
.frame{
  width: 100%;
  height: 80vh;
  iframe{
    width: 100%;
    height: 100%;
  }
}
</style>
